/* tslint:disable */
/* eslint-disable */
/**
 * lq.api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PotentialConditionsPotentialCondition
 */
export interface PotentialConditionsPotentialCondition {
    /**
     * 
     * @type {string}
     * @memberof PotentialConditionsPotentialCondition
     */
    headerCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PotentialConditionsPotentialCondition
     */
    condition?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PotentialConditionsPotentialCondition
     */
    providerGenerated?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PotentialConditionsPotentialCondition
     */
    demographicPrevalence?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PotentialConditionsPotentialCondition
     */
    confidence?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PotentialConditionsPotentialCondition
     */
    contributingFactors?: string | null;
}

export function PotentialConditionsPotentialConditionFromJSON(json: any): PotentialConditionsPotentialCondition {
    return PotentialConditionsPotentialConditionFromJSONTyped(json, false);
}

export function PotentialConditionsPotentialConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PotentialConditionsPotentialCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'headerCode': !exists(json, 'headerCode') ? undefined : json['headerCode'],
        'condition': !exists(json, 'condition') ? undefined : json['condition'],
        'providerGenerated': !exists(json, 'providerGenerated') ? undefined : json['providerGenerated'],
        'demographicPrevalence': !exists(json, 'demographicPrevalence') ? undefined : json['demographicPrevalence'],
        'confidence': !exists(json, 'confidence') ? undefined : json['confidence'],
        'contributingFactors': !exists(json, 'contributingFactors') ? undefined : json['contributingFactors'],
    };
}

export function PotentialConditionsPotentialConditionToJSON(value?: PotentialConditionsPotentialCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'headerCode': value.headerCode,
        'condition': value.condition,
        'providerGenerated': value.providerGenerated,
        'demographicPrevalence': value.demographicPrevalence,
        'confidence': value.confidence,
        'contributingFactors': value.contributingFactors,
    };
}


